import { gql } from "@apollo/client";

// Cache-write shape only — never sent over the wire.
//
// After `createContaminationDeclaration` the new declaration is already in the
// cache as a normalized entity (the mutation selects the full fragment); what
// is missing is the ROOT_QUERY link from *this event* to it, so that every
// "for event" lookup — status chips, drawer, asset section — sees it without a
// refetch. Selecting `id` alone is enough to write that link, and keeps `id`
// in the selection so the entity stays a Reference rather than degrading into
// an inline copy (see `src/utils/graphqlCacheSafety.test.ts`, case B).
//
// Deliberately *not* `ContaminationDeclarationForEvent`: that document also
// selects `contaminationDeclarationAvailability`, and writing it here would
// overwrite a cached region verdict with whatever the callback happened to
// know. A create does not change whether the form is offered.
export const ContaminationDeclarationForEventLink = gql`
    query ContaminationDeclarationForEventLink ($installedBaseEventId: ID!) {
        contaminationDeclarationForEvent (installedBaseEventId: $installedBaseEventId) {
            id
        }
    }
`;
